module.exports = __webpack_public_path__ + "static/media/trade-service.c1e9099f.svg";